import { EventTask, useTimezoneService } from 'nekst-api';
import React from 'react';
import { LoadingAnimation } from 'ui-builder';
import { useDataLoaderNew } from 'data-loader';
import { useEventPreviewService } from './eventPreviewService';
import Layout from './Layout';

export function EventPreview(
  props: {
    task: EventTask;
  }
) {
  const task = props.task;

  const previewService = useEventPreviewService();

  const timezoneService = useTimezoneService();

  const { data: eventPreview } = useDataLoaderNew(
    async () => {
      if (task.id) {
        return previewService.getEventPreview(task.id, task)
      } else {
        return previewService.getEventPreviewForProject(task.projectId, task);
      }
    }
  );

  if (eventPreview) {
    return (
      <Layout
        preview={eventPreview}
        timezone={task.dueDate?.timezone || timezoneService.getTimezone()}
      />
    );
  } else {
    return (
      <LoadingAnimation />
    );
  }
}
